namespace Vit {
    export class CompositeTaskForm {
        protected template: string;
        public forms: IForm[];
        public serviceUrl: string;
        public constructor(formKey: string) {
            if (formKey)
                this.forms = [{
                    formId: formKey,
                    formKey: formKey,
                    readOnly: false,
                }];
        }

        createTemplate(): string {
            return this.taskFormTemplate;
        }

        taskFormTemplate = `<div id="~_Tabs" class="s-DialogContent">
    <ul>
        <li><a href="#~_TaskTab"><span> فعالیت </span></a></li>
        <li><a onclick='return loadTaskHistory()' href="#~_HistoryTab"><span>تاریخچه</span></a></li>
    </ul>

    <div id="~_TaskTab" class="tab-pane s-TabOrder">
        <div id="~_Toolbar" class="s-DialogToolbar">
        </div>
        <div class="s-Form">
            <form id="~_Form" action="">
                <div class="fieldset ui-widget ui-widget-content ui-corner-all">
                    <div id="~_PropertyGrid"></div>

                    <div class="clear"></div>

                    <ul class="nav nav-tabs property-tabs">
                      <li class="active"><a data-toggle="tab" role="tab" href="#tab1">tab1</a></li>
                      <li><a data-toggle="tab" role="tab" href="#tab2">tab2</a></li>
                    </ul>
                    <div class="tab-content">
                      <div id="tab1" class="tab-pane fade in active">
                        <h3>HOME</h3>
                        <p>Home content......</p>
                      </div>
                      <div id="tab2" class="tab-pane fade">
                        <h3>Menu 1</h3>
                        <p>Some content in menu 1.</p>
                      </div>
                    </div>

                </div>
            </form>
        </div>
    </div>

    <div id="~_HistoryTab" class="tab-pane s-TabCustomer">
      <div id="TaskHistoryGridDiv"></div>
    </div>

</div>`;

    }
    export interface IFormDefintion {
        template?: string;
        forms: IForm[];
    }
    export interface IForm {
        formId?: string;
        formKey: string;
        readOnly?: boolean;
        loadByIdField?: string;
    }
}

namespace Q {
    var formDefinitions: { [formUrl: string]: (formQuery?: { [key: string]: string; }) => Vit.CompositeTaskForm; } = {};
    export function setTaskForm(formUrl: string, formFactory: (formQuery?: { [key: string]: string; }) => Vit.CompositeTaskForm): void {
        formDefinitions[formUrl] = formFactory;
    }
    export function getTaskForm(formUrl: string, serviceUrl: string, formQuery: { [key: string]: string; }): Vit.CompositeTaskForm {
        var formFactory = formDefinitions[formUrl];
        if (formFactory)
            return formFactory(formQuery);

        var defaultTaskForm = new Vit.CompositeTaskForm("");
        defaultTaskForm.serviceUrl = serviceUrl;
        defaultTaskForm.forms = [{
            formKey: formUrl,
        }];
        return defaultTaskForm;
    }
}

